import React from 'react';
import { useStyles } from 'components/Statistics/styles';

import StatisticsDownloadButton from 'components/Button/StatisticsDownloadButton';

import { CartesianGrid, Line, LineChart, Tooltip, XAxis, YAxis } from 'recharts';

import _ from 'lodash';
import { CHART_COLORS, CHART_HEIGHT, CHART_WIDTH } from './Statistics';
import { ExportTaskType } from 'commons/vo/param/StatisticsExportParamVO';
import { formatNumberWithComma, formatTooltipLabel } from './utils';

type PartialProps = {
  statisticsPartialData: LineChartData[];
  startDate: string;
  endDate: string;
};

function Partial({ statisticsPartialData, startDate, endDate }: PartialProps) {
  const classes = useStyles();

  return (
    <div className={classes.section}>
      <div className={classes.sectionTitleBox}>
        <div className={classes.sectionTitle}>부분인출</div>
        <StatisticsDownloadButton
          taskType={ExportTaskType.Partial}
          startDate={startDate}
          endDate={endDate}
        />
      </div>

      <div className={classes.sectionBody}>
        <LineChart
          width={CHART_WIDTH}
          height={CHART_HEIGHT}
          data={statisticsPartialData}
          margin={{ top: 30, bottom: 5, left: 25, right: 25 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis label={{ value: '횟수', position: 'top', offset: 15 }} width={30} />
          <Tooltip
            labelFormatter={value => {
              return [formatTooltipLabel(value)];
            }}
            formatter={value => {
              return [`${formatNumberWithComma(value)}회`, '총 부분인출'];
            }}
          />
          <Line dataKey="value" stroke={CHART_COLORS.default} isAnimationActive={false} />
        </LineChart>
      </div>
    </div>
  );
}

export default Partial;
